import { Deserializable } from '../../common/utility/deserializable.model';
import { PaymentEnum } from '../../common/utility/payment-enum';
import * as moment from 'moment';

export class PaymentPlan implements Deserializable {

  public sid: number;

  // Frequency ------------------------
  public frequencyObj: any;

  public frequency: any;

  // Account ------------------------
  public accountObj: any;

  public account: any;

  // Others ------------------------

  public paymentIsFull: boolean;

  public amount: string;

  public active: string;

  public event: PaymentPlanEvent;

  public wallet: PaymentPlanWallet;

  public contact: PaymentPlanContact;

    constructor() {
        this.accountObj = null;
        this.event = new PaymentPlanEvent();
        this.wallet = new PaymentPlanWallet();
        this.contact = new PaymentPlanContact();
        this.frequencyObj = null;
  }

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}

export class PaymentPlanEvent implements Deserializable {

  public endEventObj: any;

  public endEvent: number;

  public startDate: any;

  public endDate: any;

  public numberOfPayment: number;

  constructor() {
    this.endEventObj = null;
    const today = new Date();
    const tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000));
    this.endEvent = -1;
    this.startDate = {
      year: tomorrow.getFullYear(),
      month: tomorrow.getMonth() + 1,
      day: tomorrow.getDate()
    };

    const afterOneYear = new Date(this.startDate.year + 1, this.startDate.month - 1, this.startDate.day);
    this.endDate = {
      year: afterOneYear.getFullYear(),
      month: afterOneYear.getMonth() + 1,
      day: afterOneYear.getDate()
    };
  }

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}

export class PaymentPlanWallet implements Deserializable {

  public walletObj: any;

  public wallet: any;

  public walletSid: number;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}

export class PaymentPlanContact implements Deserializable {

  public email: string;

  public phoneNumber: string;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
export class PaymentPlanDefaults {
  public static readonly paymentEvents: PaymentEnum[] = [
    { id: 0, label: 'By Date' },
    { id: 1, label: 'By Number of Payments' },
    { id: 2, label: 'Indefinite' },
  ];

  public static readonly CONSTANT_USERNAME = 'username';

  public static readonly CONSTANT_TRANSACTION_ID = 'transactionId';


  public static readonly CONSTANT_DEFAULT_SETTINGS = 'defaultSettings';
}
